
// Spanish translations
export const es = {
  // Navigation
  navigation: {
    services: "Servicios",
    howWeWork: "Cómo Trabajamos",
    technologies: "Tecnologías",
    caseStudies: "Casos de Estudio",
    contact: "Contacto",
  },
  // Hero section
  hero: {
    title: "Soluciones Impulsadas por IA para Empresas Modernas",
    subtitle: "Creamos aplicaciones inteligentes que impulsan la eficiencia, la innovación y el crecimiento",
    ctaButton: "Comenzar",
    secondaryButton: "Saber Más",
  },
  // Services section
  services: {
    title: "Nuestros Servicios",
    subtitle: "Conjunto completo de servicios diseñados para ayudar a las empresas a aprovechar el poder de la IA y los datos",
    description: "Ofrecemos una suite completa de soluciones de IA adaptadas a las necesidades de su empresa",
    learnMore: "Saber más"
  },
  // Industries section
  industries: {
    title: "Industrias que Servimos",
    manufacturing: "Fabricación",
    infrastructure: "Infraestructura",
    warehouses: "Almacenes",
    supplyChain: "Cadena de Suministro",
    categories: {
      industrialMachinery: "Maquinaria Industrial",
      threeDPrinting: "Impresión 3D",
      roboticSolutions: "Soluciones Robóticas",
      energy: "Energía",
      dataCenters: "Centros de Datos",
      governmentFacilities: "Instalaciones Gubernamentales",
      distributionCenters: "Centros de Distribución",
      coldStorage: "Almacenamiento en Frío",
      microFulfillment: "Micro-fulfillment",
      retail: "Minorista",
      foodAndAgriculture: "Alimentación y Agricultura",
      logisticsAndTransportation: "Logística y Transporte",
    },
  },
  // Process section
  process: {
    title: "Nuestro Proceso",
  },
  // Technologies section
  technologies: {
    title: "Tecnologías",
  },
  // Tools section
  tools: {
    title: "Herramientas que Utilizamos",
  },
  // Case studies section
  caseStudies: {
    title: "Casos de Estudio",
    viewAllButton: "Ver Todos los Casos de Estudio",
  },
  // Contact section
  contact: {
    title: "Contáctenos",
    name: "Nombre",
    email: "Correo Electrónico",
    message: "Mensaje",
    submitButton: "Enviar Mensaje",
  },
  // Footer
  footer: {
    company: "Empresa",
    about: "Acerca de",
    careers: "Carreras",
    resources: "Recursos",
    legal: "Legal",
    privacyPolicy: "Política de Privacidad",
    terms: "Términos",
    cookiePolicy: "Política de Cookies",
    copyright: "© 2025 KLEXU. Todos los derechos reservados.",
  },
};
